export enum ToolMaterialId {
  HSS = 1,
  Cobalt = 2,
  Carbide = 3,
  PCD = 4,
  Ceramic = 5,
  Unspecified = 6,
  TiCoated = 7,
}

// Model ToolMaterial
export type ToolMaterial = {
  id: ToolMaterialId
  name: string
  surfaceSpeedFactor: number //sfm
  chipLoadFactor: number // ipt
  rigid: number
  maxDeviation: number // dev_max
  ultimateTensileStrength: number // utx
}

// Legacy data from tool_materials table
export const TOOL_MATERIALS: Array<ToolMaterial> = [
  {
    id: 1,
    name: 'HSS',
    surfaceSpeedFactor: 1, //sfm
    chipLoadFactor: 1, // ipt
    rigid: 18000000,
    maxDeviation: 0.0025, // dev_max
    ultimateTensileStrength: 145037, // utx
  },
  {
    id: 2,
    name: 'Cobalt',
    surfaceSpeedFactor: 1.2,
    chipLoadFactor: 1.1,
    rigid: 18000000,
    maxDeviation: 0.0025,
    ultimateTensileStrength: 145037,
  },
  {
    id: 3,
    name: 'Carbide',
    surfaceSpeedFactor: 3.529,
    chipLoadFactor: 1.2,
    rigid: 49000000,
    maxDeviation: 0.0025,
    ultimateTensileStrength: 200000,
  },
  {
    id: 4,
    name: 'PCD',
    surfaceSpeedFactor: 8,
    chipLoadFactor: 1.2,
    rigid: 18000000,
    maxDeviation: 0.0025,
    ultimateTensileStrength: 120000,
  },
  {
    id: 5,
    name: 'Ceramic',
    surfaceSpeedFactor: 40,
    chipLoadFactor: 0.75,
    rigid: 18000000,
    maxDeviation: 0.0025,
    ultimateTensileStrength: 120000,
  },
  {
    id: 6,
    name: 'Unspecified',
    surfaceSpeedFactor: 0,
    chipLoadFactor: 0,
    rigid: 0,
    maxDeviation: 0,
    ultimateTensileStrength: 0,
  },
  {
    id: 7,
    name: 'Ti Coated',
    surfaceSpeedFactor: 0,
    chipLoadFactor: 0,
    rigid: 0,
    maxDeviation: 0,
    ultimateTensileStrength: 0,
  },
]

export const TOOL_MATERIALS_BY_ID = TOOL_MATERIALS.reduce((acc, material) => {
  acc[material.id] = material
  return acc
}, {} as Record<ToolMaterialId, ToolMaterial>)

export const getToolMaterialFromId = (id: ToolMaterialId) => {
  return TOOL_MATERIALS_BY_ID[id]
}

export const getNameFromToolMaterialId = (id: ToolMaterialId) => {
  return TOOL_MATERIALS_BY_ID[id]?.name
}
